/**
 * The day cap Spend suggests to an enterprise with no caps yet, in cents. One constant, so the words that
 * suggest it and the add-cap form that carries it can never drift apart.
 */
export const SUGGESTED_DAY_CAP_CENTS = 1000
